import React from 'react';

export const inventories = [
  {
    image: require('./images/small/Connecticut Historical Society.jpg'),
    titleStr: 'Connecticut Museum of Culture and History',
    title: (
      <>
        Connecticut Museum of
        <br />
        Culture and History
      </>
    ),
    filePath: require('./files/CT Hartford, Connecticut Museum of Culture and History.pdf'),
    alt: 'Connecticut Museum of Culture and History',
    imageLarge: require('./images/large/Connecticut Historical Society--large.jpg'),
    // caption:
    //   'About 1802 the first movement toward chanting was made by the Rev. William A. Smith...',
  },
  {
    image: require('./images/small/Watkinson Library, Trinity College.jpg'),
    titleStr: 'Trinity College, Watkinson Library',
    title: (
      <>
        Trinity College,
        <br />
        Watkinson Library
      </>
    ),
    filePath: require('./files/CT Hartford, Trinity College, Watkinson Library.pdf'),
    alt: 'Trinity College, Watkinson Library',
    imageLarge: require('./images/large/Watkinson Library, Trinity College--large.jpg'),
    // caption:
    //   'Before the introduction of the viol and the flute and the worldly fiddle, ‘the only instrumental music,’ says the same writer [Rev. Theodore J. Holmes], ‘came from the pitch-pipe in the hands of the leader...',
  },
  {
    image: require('./images/small/Olin Memorial Library (Special Collections), Wesleyan University.jpg'),
    titleStr: 'Wesleyan University, Olin Memorial Library',
    title: (
      <>
        Wesleyan University,
        <br />
        Olin Memorial Library
      </>
    ),
    filePath: require('./files/CT Middletown, Wesleyan University, Olin Memorial Library.pdf'),
    alt: 'Wesleyan University, Olin Memorial Library',
    imageLarge: require('./images/large/Olin Memorial Library (Special Collections), Wesleyan University--large.jpg'),
    // caption:
    //   'If space permitted, it might be amusing to refer to some of the matters upon which the public mind was agitated at different times in the Colony and Province...',
  },
  {
    image: require('./images/small/Andover Center for History and Culture.jpg'),
    titleStr: 'Andover Center for History and Culture',
    title: (
      <>
        Andover Center for
        <br /> History and Culture
      </>
    ),
    filePath: require('./files/MA Andover, Andover Center for History and Culture.pdf'),
    alt: 'Andover Center for History and Culture',
    imageLarge: require('./images/large/Andover Center for History and Culture--large.jpg'),
    // caption:
    //   'The favor in which the choir was held was also manifested by several appropriations of money for their benefit, which were expended in the maintenance of singing-schools...',
  },
  {
    image: require('./images/small/Boston Athenaeum.jpg'),
    titleStr: 'Boston Athenaeum',
    title: <>Boston Athenaeum</>,
    filePath: require('./files/MA Boston, Boston Athenaeum.pdf'),
    alt: 'Boston Athenaeum',
    imageLarge: require('./images/large/Boston Athenaeum--large.jpg'),
    // caption:
    //   'In the early days of the New England colonies the violin, violoncello, bass viol and flute were for the most part the instruments in use, both in religious and secular circles.',
  },
  {
    image: require('./images/small/Congregational Library and Archives.jpg'),
    titleStr: 'Congregational Library and Archives',
    title: <>Congregational Library and Archives</>,
    filePath: require('./files/MA Boston, Congregational Library and Archives.pdf'),
    alt: 'Congregational Library and Archives',
    imageLarge: require('./images/large/Congregational Library and Archives--large.jpg'),
    // caption:
    //   'Farewell, Litchfield and Goshen, a country of storm and winter and frightful cold and snow, and of hardy, active, reading, thinking, intelligent men...',
  },
  {
    image: require('./images/small/Harvard Musical Association and environs.jpg'),
    titleStr: 'Harvard Musical Association',
    title: <>Harvard Musical Association</>,
    filePath: require('./files/MA Boston, Harvard Musical Association.pdf'),
    alt: 'Harvard Musical Association',
    imageLarge: require('./images/large/Harvard Musical Association and environs--large.jpg'),
  },
  {
    image: require('./images/small/Massachusetts Historical Society.jpg'),
    titleStr: 'Massachusetts Historical Society',
    title: <>Massachusetts Historical Society</>,
    filePath: require('./files/MA Boston, Massachusetts Historical Society.pdf'),
    alt: 'Massachusetts Historical Society',
    imageLarge: require('./images/large/Massachusetts Historical Society--large.jpg'),
  },
  {
    image: require('./images/small/Divinity School Library, Harvard University.jpg'),
    titleStr: 'Harvard University, Divinity School Library',
    title: (
      <>
        Harvard University,
        <br />
        Divinity School Library
      </>
    ),
    filePath: require('./files/MA Cambridge, Harvard University, Divinity School Library.pdf'),
    alt: 'Harvard University, Divinity School Library',
    imageLarge: require('./images/large/Divinity School Library, Harvard University--large.jpg'),
  },
  {
    image: require('./images/small/Harvard University Archives.jpg'),
    titleStr: 'Harvard University Archives',
    title: <>Harvard University Archives</>,
    filePath: require('./files/MA Cambridge, Harvard University Archives.pdf'),
    alt: 'Harvard University Archives',
    imageLarge: require('./images/large/Harvard University Archives--large.jpg'),
  },
  {
    image: require('./images/small/Houghton Library, Harvard University.jpg'),
    titleStr: 'Harvard University, Houghton Library',
    title: (
      <>
        Harvard University,
        <br />
        Houghton Library
      </>
    ),
    filePath: require('./files/MA Cambridge, Harvard University, Houghton Library.pdf'),
    alt: 'Harvard University, Houghton Library',
    imageLarge: require('./images/large/Houghton Library, Harvard University--large.jpg'),
  },
  {
    image: require('./images/small/Loeb Music Library, Harvard University.jpg'),
    titleStr: 'Harvard University, Eda Kuhn Loeb Music Library',
    title: (
      <>
        Harvard University,
        <br />
        Eda Kuhn Loeb Music Library
      </>
    ),
    filePath: require('./files/MA Cambridge, Harvard University, Eda Kuhn Loeb Music Library.pdf'),
    alt: 'Harvard University, Eda Kuhn Loeb Music Library',
    imageLarge: require('./images/large/Loeb Music Library, Harvard University--large.jpg'),
  },
  {
    image: require('./images/small/Widener Library, Harvard University.jpg'),
    titleStr: 'Harvard University, Widener Library',
    title: (
      <>
        Harvard University,
        <br />
        Widener Library
      </>
    ),
    filePath: require('./files/MA Cambridge, Harvard University, Widener Library.pdf'),
    alt: 'Harvard University, Widener Library',
    imageLarge: require('./images/large/Widener Library, Harvard University--large.jpg'),
  },
  {
    image: require('./images/small/Henry N. Flynt Library, Historic Deerfield.jpg'),
    titleStr: 'Historic Deerfield, Henry N. Flynt Library',
    title: (
      <>
        Historic Deerfield,
        <br />
        Henry N. Flynt Library
      </>
    ),
    filePath: require('./files/MA Deerfield, Historic Deerfield, Henry N. Flynt Library.pdf'),
    alt: 'Historic Deerfield, Henry N. Flynt Library',
    imageLarge: require('./images/large/Henry N. Flynt Library, Historic Deerfield--large.jpg'),
  },
  {
    image: require('./images/small/Pocumtuck Valley Memorial Association Library, Historic Deerfield.jpg'),
    titleStr: 'Pocumtuck Valley Memorial Association Library',
    title: (
      <>
        Pocumtuck Valley
        <br />
        Memorial Association Library
      </>
    ),
    filePath: require('./files/MA Deerfield, Pocumtuck Valley Memorial Association Library.pdf'),
    alt: 'Pocumtuck Valley Memorial Association Library',
    imageLarge: require('./images/large/Pocumtuck Valley Memorial Association Library, Historic Deerfield--large.jpg'),
  },
  {
    image: require('./images/small/Nym Cooke collection.jpg'),
    titleStr: 'Nym Cooke Collection',
    title: <>Nym Cooke Collection</>,
    filePath: require('./files/MA Petersham, Nym Cooke collection.pdf'),
    alt: 'Nym Cooke Collection',
    imageLarge: require('./images/large/Nym Cooke collection--large.jpg'),
  },
  {
    image: require('./images/small/Phillips Library, Peabody Essex Museum.jpg'),
    titleStr: 'Peabody Essex Museum, Phillips Library',
    title: (
      <>
        Peabody Essex Museum,
        <br />
        Phillips Library
      </>
    ),
    filePath: require('./files/MA Rowley, Peabody Essex Museum, Phillips Library.pdf'),
    alt: 'Peabody Essex Museum, Phillips Library',
    imageLarge: require('./images/large/Phillips Library, Peabody Essex Museum--large.jpg'),
  },
  {
    image: require('./images/small/American Antiquarian Society.jpg'),
    titleStr: 'American Antiquarian Society',
    title: <>American Antiquarian Society</>,
    filePath: require('./files/MA Worcester, American Antiquarian Society.pdf'),
    alt: 'American Antiquarian Society',
    imageLarge: require('./images/large/American Antiquarian Society--large.jpg'),
  },
  {
    image: require('./images/small/John Carter Brown Library, Brown University.jpg'),
    titleStr: 'Brown University, John Carter Brown Library',
    title: (
      <>
        Brown University,
        <br />
        John Carter Brown Library
      </>
    ),
    filePath: require('./files/RI Providence, Brown University, John Carter Brown Library.pdf'),
    alt: 'Brown University, John Carter Brown Library',
    imageLarge: require('./images/large/John Carter Brown Library, Brown University--large.jpg'),
  },
  {
    image: require('./images/small/John Hay Library, Brown University.jpg'),
    titleStr: 'Brown University, John Hay Library',
    title: (
      <>
        Brown University,
        <br />
        John Hay Library
      </>
    ),
    filePath: require('./files/RI Providence, Brown University, John Hay Library.pdf'),
    alt: 'Brown University, John Hay Library',
    imageLarge: require('./images/large/John Hay Library, Brown University--large.jpg'),
  },
  {
    image: require('./images/small/Providence Athenaeum.jpg'),
    titleStr: 'Providence Athenaeum',
    title: <>Providence Athenaeum</>,
    filePath: require('./files/RI Providence, Providence Athenaeum.pdf'),
    alt: 'Providence Athenaeum',
    imageLarge: require('./images/large/Providence Athenaeum--large.jpg'),
  },
  {
    image: require('./images/small/Mary Elizabeth Robinson Research Center, Rhode Island Historical Society.jpg'),
    titleStr: 'Rhode Island Historical Society',
    title: <>Rhode Island Historical Society</>,
    filePath: require('./files/RI Providence, Rhode Island Historical Society, Mary Elizabeth Robinson Research Center.pdf'),
    alt: 'Rhode Island Historical Society, Mary Elizabeth Robinson Research Center',
    imageLarge: require('./images/large/Mary Elizabeth Robinson Research Center, Rhode Island Historical Society--large.jpg'),
  },
  {
    image: require('./images/small/MA Sturbridge, Old Sturbridge Village Research Library.jpg'),
    titleStr: 'Old Sturbridge Village Research Library',
    title: (
      <>
        Old Sturbridge Village
        <br />
        Research Library
      </>
    ),
    filePath: require('./files/MA Sturbridge, Old Sturbridge Village Research Library.pdf'),
    alt: 'Old Sturbridge Village Research Library',
    imageLarge: require('./images/large/MA Sturbridge, Old Sturbridge Village Research Library--large.jpg'),
  },
  {
    image: require('./images/small/Boston Pubic Library.jpg'),
    titleStr: 'Boston Public Library',
    title: <>Boston Public Library</>,
    filePath: require('./files/MA Boston, Boston Public Library.pdf'),
    alt: 'MA Boston, Boston Public Library',
    imageLarge: require('./images/large/Boston Pubic Library.jpg'),
  },
  {
    image: require('./images/small/William L. Clements Library.jpg'),
    titleStr: 'University of Michigan, William L. Clements Library',
    title: (
      <>
        University of Michigan,
        <br />
        William L. Clements Library
      </>
    ),
    filePath: require('./files/MI Ann Arbor, University of Michigan, William L. Clements Library.pdf'),
    alt: 'University of Michigan, William L. Clements Library',
    imageLarge: require('./images/large/William L. Clements Library.jpg'),
  },
  {
    image: require('./images/small/University of Michigan, Music Library.jpg'),
    titleStr: 'University of Michigan, Music Library',
    title: (
      <>
        University of Michigan,
        <br />
        Music Library
      </>
    ),
    filePath: require('./files/MI Ann Arbor, University of Michigan, Music Library.pdf'),
    alt: 'University of Michigan, Music Library',
    imageLarge: require('./images/large/University of Michigan, Music Library.jpg'),
  },
  {
    image: require('./images/small/University of Vermont, Silver Special Collections Library.jpg'),
    titleStr: 'University of Vermont, Silver Special Collections',
    title: (
      <>
        University of Vermont,
        <br />
        Silver Special Collections
      </>
    ),
    filePath: require('./files/VT Burlington, University of Vermont, Silver Special Collections Library.pdf'),
    alt: 'VT Burlington, University of Vermont, Silver Special Collections Library',
    imageLarge: require('./images/large/University of Vermont, Silver Special Collections Library.jpg'),
  },
  {
    image: require('./images/small/Bennington Museum.jpg'),
    titleStr: 'Bennington Museum',
    title: <>Bennington Museum</>,
    filePath: require('./files/VT Bennington, Bennington Museum.pdf'),
    alt: 'VT Bennington, Bennington Museum',
    imageLarge: require('./images/large/Bennington Museum.jpg'),
  },
  {
    image: require('./images/small/Vermont Historical Society, Leahy Library.jpg'),
    titleStr: 'Vermont Historical Society, Leahy Library',
    title: (
      <>
        Vermont Historical Society,
        <br />
        Leahy Library
      </>
    ),
    filePath: require('./files/VT Barre, Vermont Historical Society, Howard & Alba Leahy Library.pdf'),
    alt: 'VT Barre, Vermont Historical Society, Howard & Alba Leahy Library',
    imageLarge: require('./images/large/Vermont Historical Society, Leahy Library.jpg'),
  },
  {
    image: require('./images/small/Forbes Library.jpg'),
    titleStr: 'Forbes Library',
    title: <>Forbes Library</>,
    filePath: require('./files/MA Northampton, Forbes Library.pdf'),
    alt: 'MA Northampton, Forbes Library',
    imageLarge: require('./images/large/Forbes Library.jpg'),
  },
  {
    image: require('./images/small/Amherst College.jpg'),
    titleStr: 'Amherst College',
    title: <>Amherst College</>,
    filePath: require('./files/MA Amherst, Amherst College.pdf'),
    alt: 'MA Amherst, Amherst College',
    imageLarge: require('./images/large/Amherst College.jpg'),
  },
];

export const sortedInventories = () =>
  inventories.sort((a, b) => a.titleStr.localeCompare(b.titleStr));
